import { rest } from 'msw'

export default [
  /**
   * プラント情報
   */
  rest.get('/swc-api/master/plants', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "id": 1,
            "name": "排水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "2",
            "organization_name": "C 社",
            "industry_type_code": "drainage",
            "industry_type_name": "排水処理",
            "site_id": 1,
            "site_name": "蔵王工場",
            "node_list": [
                {
                    "id": 1,
                    "name": "排水処理 MBR",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "2",
                    "organization_name": "C 社",
                    "facility_group_code": "MBR",
                    "facility_group_name": "MBR",
                    "plant_id": 1,
                    "plant_name": "排水処理",
                    "dashboard_settings": null,
                    "site_id": 1,
                    "site_name": "蔵王工場"
                }
            ]
        },
        {
            "id": 2,
            "name": "移動脱水車",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "4",
            "organization_name": "島根県水道局",
            "industry_type_code": "mobile_dehydration",
            "industry_type_name": "移動脱水車",
            "site_id": 2,
            "site_name": "S 浄化センター",
            "node_list": [
                {
                    "id": 4,
                    "name": "移動脱水車 3 系統",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "4",
                    "organization_name": "島根県水道局",
                    "facility_group_code": null,
                    "plant_id": 2,
                    "plant_name": "移動脱水車",
                    "dashboard_settings": null,
                    "site_id": 2,
                    "site_name": "S 浄化センター"
                },
                {
                    "id": 3,
                    "name": "移動脱水車 2 系統",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "4",
                    "organization_name": "島根県水道局",
                    "facility_group_code": null,
                    "plant_id": 2,
                    "plant_name": "移動脱水車",
                    "dashboard_settings": null,
                    "site_id": 2,
                    "site_name": "S 浄化センター"
                },
                {
                    "id": 2,
                    "name": "移動脱水車 1 系統",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "4",
                    "organization_name": "島根県水道局",
                    "facility_group_code": null,
                    "plant_id": 2,
                    "plant_name": "移動脱水車",
                    "dashboard_settings": null,
                    "site_id": 2,
                    "site_name": "S 浄化センター"
                }
            ]
        },
        {
            "id": 3,
            "name": "排水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "5",
            "organization_name": "TK 大学",
            "industry_type_code": "drainage",
            "industry_type_name": "排水処理",
            "site_id": 3,
            "site_name": "TK 大学",
            "node_list": [
                {
                    "id": 5,
                    "name": "排水処理",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "5",
                    "organization_name": "TK 大学",
                    "facility_group_code": null,
                    "plant_id": 3,
                    "plant_name": "排水処理",
                    "dashboard_settings": null,
                    "site_id": 3,
                    "site_name": "TK 大学"
                }
            ]
        },
        {
            "id": 4,
            "name": "用水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "6",
            "organization_name": "A 社",
            "industry_type_code": "aqueduct",
            "industry_type_name": "用水処理",
            "site_id": 4,
            "site_name": "名古屋工場",
            "node_list": [
                {
                    "id": 6,
                    "name": "用水処理処理 RO",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "6",
                    "organization_name": "A 社",
                    "facility_group_code": "RO",
                    "facility_group_name": "RO",
                    "plant_id": 4,
                    "plant_name": "用水処理",
                    "dashboard_settings": null,
                    "site_id": 4,
                    "site_name": "名古屋工場"
                }
            ]
        },
        {
            "id": 5,
            "name": "用水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "industry_type_code": "aqueduct",
            "industry_type_name": "用水処理",
            "site_id": 5,
            "site_name": "宇治川工場",
            "node_list": [
                {
                    "id": 7,
                    "name": "用水処理 SaiForce",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "3",
                    "organization_name": "S 社",
                    "facility_group_code": "SaiForce",
                    "facility_group_name": "SaiForce",
                    "plant_id": 5,
                    "plant_name": "用水処理",
                    "dashboard_settings": null,
                    "site_id": 5,
                    "site_name": "宇治川工場"
                }
            ]
        },
        {
            "id": 6,
            "name": "用水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "industry_type_code": "aqueduct",
            "industry_type_name": "用水処理",
            "site_id": 6,
            "site_name": "多摩川工場",
            "node_list": [
                {
                    "id": 8,
                    "name": "用水処理 SaiForce",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "3",
                    "organization_name": "S 社",
                    "facility_group_code": "SaiForce",
                    "facility_group_name": "SaiForce",
                    "plant_id": 6,
                    "plant_name": "用水処理",
                    "dashboard_settings": null,
                    "site_id": 6,
                    "site_name": "多摩川工場"
                }
            ]
        },
        {
            "id": 7,
            "name": "用水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "2",
            "organization_name": "C 社",
            "industry_type_code": "aqueduct",
            "industry_type_name": "用水処理",
            "site_id": 1,
            "site_name": "蔵王工場",
            "node_list": [
                {
                    "id": 9,
                    "name": "排水処理 SaiForce",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "2",
                    "organization_name": "C 社",
                    "facility_group_code": "SaiForce",
                    "facility_group_name": "SaiForce",
                    "plant_id": 7,
                    "plant_name": "用水処理",
                    "dashboard_settings": null,
                    "site_id": 1,
                    "site_name": "蔵王工場"
                }
            ]
        },
        {
            "id": 8,
            "name": "排水処理",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "7",
            "organization_name": "P 社",
            "industry_type_code": "drainage",
            "industry_type_name": "排水処理",
            "site_id": 7,
            "site_name": "群馬工場",
            "node_list": [
                {
                    "id": 10,
                    "name": "排水処理 MBR",
                    "image": "",
                    "specification": null,
                    "construction_memo": null,
                    "organization_code": "7",
                    "organization_name": "P 社",
                    "facility_group_code": "MBR",
                    "facility_group_name": "MBR",
                    "plant_id": 8,
                    "plant_name": "排水処理",
                    "dashboard_settings": null,
                    "site_id": 7,
                    "site_name": "群馬工場"
                }
            ]
        }
    ]),
    )
  }),
  /**
   * プラント詳細情報
   */
  rest.get('/swc-api/master/plants/:plant_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "id": 1,
        "name": "排水処理",
        "specification": null,
        "construction_memo": null,
        "image": null,
        "organization_code": "2",
        "organization_name": "C 社",
        "industry_type_code": "drainage",
        "industry_type_name": "排水処理",
        "site_id": 1,
        "site_name": "蔵王工場",
        "node_list": [
            {
                "id": 1,
                "name": "排水処理 MBR",
                "image": "",
                "specification": null,
                "construction_memo": null,
                "organization_code": "2",
                "organization_name": "C 社",
                "facility_group_code": "MBR",
                "facility_group_name": "MBR",
                "plant_id": 1,
                "plant_name": "排水処理",
                "dashboard_settings": null,
                "site_id": 1,
                "site_name": "蔵王工場"
            }
        ]
    }),
    )
  }),
  /**
   * プラント情報新規登録
   */
  rest.post('/swc-api/master/plants', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * プラント情報更新
   */
  rest.put('/swc-api/master/plants/:plant_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * プラント情報削除
   */
  rest.delete('/swc-api/master/plants/:plant_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
